export default __webpack_public_path__ + "static/media/facebooklogo.9c78a48b.svg";